import FinancialReportModule from "./report_financial/components/FinancialReportModule";

export default function ReportFinancial() {
   
    return (
        <>
           <FinancialReportModule />
        </>
    );
}